import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import {
  useVesselContext,
  vesselDialogs,
} from '../../../Contexts/Modules/SampleModule/VesselModule'
import { getCodeSetLabelLookup } from '../../../Functions/CodeSetFns'
import { useUserContext } from '../../../Contexts/UserConfig'
import { LoadingButton } from '@mui/lab'
import { useMessagePopupContext } from '../../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useStuartMutate } from '../../../APIs/Hooks/PhpAPIHooks'

function NewStatusConfirmDialog() {
  const { loginConfig } = useUserContext()
  const { openDialog, setOpenDialog, fields, vesselQuery } = useVesselContext()
  const { setMessage } = useMessagePopupContext()
  const { mutate: changeStatus, isLoading } = useStuartMutate(
    `/vessel/changeVesselStatus.php?ToStatusID=${fields?.vesselStatus}&VesselID=${vesselQuery.data?.VesselID}`,
    (data) => {
      if (data?.Success) {
        setOpenDialog(undefined)
      } else {
        setMessage({
          subject: 'Error',
          severity: 'warning',
          message:
            data?.message ??
            'An unexpected error occurred changing the vessel status',
        })
      }
    },
  )
  return (
    <Dialog
      open={openDialog === vesselDialogs.STATUS_CONFIRM}
      onClose={() => setOpenDialog(undefined)}
    >
      <DialogTitle>{'Update Sample Status'}</DialogTitle>
      <DialogContent>
        {`Change the status of ALL samples within this vessel (and all
        sub-vessels) to 
        "${getCodeSetLabelLookup(
          loginConfig,
          ['SampleStatusID'],
          fields?.vesselStatus,
        )}"?`}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpenDialog(undefined)}
          color="error"
        >
          Cancel
        </Button>
        <LoadingButton
          onClick={() => changeStatus()}
          color="success"
          loading={isLoading}
        >
          Change Status
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default NewStatusConfirmDialog
